import React, { forwardRef } from 'react';

import MUIFormControlLabel, {
  FormControlLabelProps as MUIFormControlLabelProps,
} from '@material-ui/core/FormControlLabel';

interface FormControlLabelProps extends MUIFormControlLabelProps {}

const FormControlLabel = forwardRef<HTMLDivElement, FormControlLabelProps>(
  (props, ref) => {
    return <MUIFormControlLabel {...props} ref={ref} />;
  }
);

FormControlLabel.displayName = 'FormControlLabel';

export default FormControlLabel;
